import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './ProjectCard.css';

export default function ProjectCard({ project }) {
  const [hovered, setHovered] = useState(false);

  return (
    <Link
      to={`/work/${project.id}`}
      className={`project-card ${hovered ? 'project-card--hovered' : ''}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="project-card__thumb">
        {project.thumbnail_url ? (
          <img src={project.thumbnail_url} alt={project.title} />
        ) : (
          <div className="project-card__placeholder">
            <span>▶</span>
          </div>
        )}
        <div className="project-card__overlay">
          <span className="project-card__play">↗</span>
        </div>
      </div>
      <div className="project-card__info">
        <h3 className="project-card__title">{project.title}</h3>
        <p className="project-card__category">{project.category}</p>
      </div>
    </Link>
  );
}
